import { useQuery } from '@tanstack/react-query';
import { aiApi, SectionRequirementsData } from '@/api/ai';

export const SECTION_REQUIREMENTS_QUERY_KEY = 'ai-section-requirements';

export function useSectionRequirements(reportId?: string | null) {
    return useQuery<SectionRequirementsData>({
        queryKey: [SECTION_REQUIREMENTS_QUERY_KEY, reportId],
        queryFn: async () => {
            const response = await aiApi.getSectionRequirements(reportId!);
            return response.data;
        },
        enabled: !!reportId,
    });
}
